export const generatePrintHTML = (order, formatStatus, getOrderNumber, getDeliveryInfo) => {
  // Helper functie om km af te ronden op 1 decimaal
  const formatKm = (km) => {
    if (!km) return 'Onbekend';
    return parseFloat(km).toFixed(1) + ' km';
  };

  // Gebruik alleen het laatste deel van order_code (bijv. C9BCC4 van KMFC-20260422-C9BCC4)
  const orderNumber = order.order_code ? `#${order.order_code.split('-').pop()}` : `#${order.id.toString().padStart(4, '0').toUpperCase()}`;
  const orderDate = new Date(order.placed_at).toLocaleDateString('nl-NL', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });
  
  // Bereken bezorgtijd: delivery_time als beschikbaar, anders ASAP als is_asap true
  const deliveryTime = order.delivery_time 
    ? new Date(order.delivery_time).toLocaleTimeString('nl-NL', {
        hour: '2-digit',
        minute: '2-digit'
      })
    : (order.is_asap && order.placed_at 
      ? new Date(new Date(order.placed_at).getTime() + 60 * 60 * 1000).toLocaleTimeString('nl-NL', {
          hour: '2-digit',
          minute: '2-digit'
        })
      : 'Geen tijd');
  
  const deliveryInfo = getDeliveryInfo(order);

  const sauceNames = [
    'Amerik. Spicy saus', 'Mayonaise', 'Ketchup', 'Mosterd', 'Curry',
    'Chilli', 'Knoflook', 'SamuraI', 'Appelmoes', 'Met appelmoes'
  ];

  const allSauces = [];

  const itemsHTML = (order.order_items || []).map(item => {
    const productNumber = item.products?.Productnummer !== undefined && item.products?.Productnummer !== null
      ? item.products.Productnummer : null;

    // Parse item_options - split on + and get individual sauces
    const options = (item.item_options || '').split('+').map(opt => opt.trim()).filter(opt => opt);
    
    // Add sauces to global list (multiply by quantity)
    options.forEach(option => {
      // Only include specific sauces, ignore other 'met' options
      const normalizedOption = option.toLowerCase().trim();
      let isSauce = false;
      let cleanName = option;
      let sauceQuantity = 1; // Default quantity
      
      // Only exact sauce matches - same logic as display filter
      const exactSauces = [
        'appelmoes',
        'mayonaise', 
        'ketchup',
        'mosterd',
        'curry',
        'chili',
        'chilli',
        'chili saus',
        'knoflook',
        'samurai',
        'amerik. spicy saus',
        'amerikaanse spicy saus'
      ];
      
      // Check if option is exactly a sauce (with or without quantity prefix)
      const isExactSauce = exactSauces.some(sauce => {
        // Remove quantity prefix like "2x " for comparison
        const optionWithoutQty = normalizedOption.replace(/^\d+x\s+/, '');
        return optionWithoutQty === sauce || 
               optionWithoutQty === `met ${sauce}` ||
               normalizedOption === `${sauce}` ||
               normalizedOption.startsWith(`${sauce} `);
      });
      
      if (isExactSauce) {
        isSauce = true;
        // Extract quantity from "2x Appelmoes" or "1x Appelmoes"
        const match = option.match(/^(\d+)x\s+/i);
        if (match) {
          sauceQuantity = parseInt(match[1]);
        }
        
        // Clean up the name
        if (normalizedOption.includes('appelmoes')) {
          cleanName = 'Appelmoes';
        } else if (normalizedOption.includes('mayonaise')) {
          cleanName = 'Mayonaise';
        } else if (normalizedOption.includes('ketchup')) {
          cleanName = 'Ketchup';
        } else if (normalizedOption.includes('mosterd')) {
          cleanName = 'Mosterd';
        } else if (normalizedOption.includes('curry')) {
          cleanName = 'Curry';
        } else if (normalizedOption.includes('chili') || normalizedOption.includes('chilli')) {
          cleanName = 'Chili';
        } else if (normalizedOption.includes('knoflook')) {
          cleanName = 'Knoflook';
        } else if (normalizedOption.includes('samurai')) {
          cleanName = 'Samurai';
        } else if (normalizedOption.includes('amerik. spicy saus') || normalizedOption.includes('amerikaanse spicy saus')) {
          cleanName = 'Amerik. Spicy saus';
        }
      }
      
      // Only add if it's a sauce
      if (isSauce) {
        // Add sauce for each quantity (from option) and item quantity
        const totalQuantity = sauceQuantity * (item.qty || 1);
        for (let i = 0; i < totalQuantity; i++) {
          allSauces.push(cleanName);
        }
      }
    });

    // Also check if this item itself is a sauce product (from Saus category)
    if (item.products?.category?.slug === 'saus' || 
        item.name_snapshot?.toLowerCase().includes('portie') ||
        (item.name_snapshot && ['PORTIE MAYO', 'PORTIE CHILI', 'PORTIE CHILLI', 'CHILI SAUS', 'PORTIE SAMURAI', 'AMERIK. SPICY SAUS', 'PORTIE CURRY', 'PORTIE KETCHUP', 'PORTIE MOSTERD', 'PORTIE KNOFLOOK', 'PORTIE APPELMOES'].includes(item.name_snapshot.toUpperCase()))) {
      
      // Clean up the sauce name (remove "PORTIE " prefix)
      let sauceName = item.name_snapshot;
      if (sauceName.toUpperCase().startsWith('PORTIE ')) {
        sauceName = sauceName.substring(7); // Remove "PORTIE "
      }
      
      // Normalize some names
      if (sauceName.toUpperCase() === 'MAYO') {
        sauceName = 'Mayonaise';
      } else if (sauceName.toUpperCase() === 'APPELMOES') {
        sauceName = 'Appelmoes';
      } else if (sauceName.toUpperCase() === 'CHILI' || sauceName.toUpperCase() === 'CHILLI') {
        sauceName = 'Chili';
      } else if (sauceName.toUpperCase() === 'SAMURAI') {
        sauceName = 'Samurai';
      } else if (sauceName.toUpperCase() === 'CURRY') {
        sauceName = 'Curry';
      } else if (sauceName.toUpperCase() === 'KETCHUP') {
        sauceName = 'Ketchup';
      } else if (sauceName.toUpperCase() === 'MOSTERD') {
        sauceName = 'Mosterd';
      } else if (sauceName.toUpperCase() === 'KNOFLOOK') {
        sauceName = 'Knoflook';
      } else if (sauceName.toUpperCase() === 'AMERIK. SPICY SAUS') {
        sauceName = 'Amerik. Spicy saus';
      }
      
      // Add sauce for each quantity
      for (let i = 0; i < (item.qty || 1); i++) {
        allSauces.push(sauceName);
      }
    }

    // Filter options for display (exclude specific sauces from product display)
    const displayOptions = options.filter(option => {
      const normalizedOption = option.toLowerCase().trim();
      
      // Only exact sauce matches - be very specific
      const exactSauces = [
        'appelmoes',
        'mayonaise', 
        'ketchup',
        'mosterd',
        'curry',
        'chili',
        'chilli',
        'chili saus',
        'knoflook',
        'samurai',
        'amerik. spicy saus',
        'amerikaanse spicy saus'
      ];
      
      // Check if option is exactly a sauce (with or without quantity prefix)
      const isExactSauce = exactSauces.some(sauce => {
        // Remove quantity prefix like "2x " for comparison
        const optionWithoutQty = normalizedOption.replace(/^\d+x\s+/, '');
        return optionWithoutQty === sauce || 
               optionWithoutQty === `met ${sauce}` ||
               normalizedOption === `${sauce}` ||
               normalizedOption.startsWith(`${sauce} `);
      });
      
      // Exclude if it's a sauce OR if it contains "zonder" with a sauce name
      const containsZonderSauce = exactSauces.some(sauce => 
        normalizedOption.includes(`zonder ${sauce}`)
      );
      
      return !isExactSauce && 
             !containsZonderSauce &&
             !normalizedOption.includes('besteld via upsell') &&
             !normalizedOption.includes('upsell');
    });

    const optionPills = displayOptions.map(option => {
      let iconClass = 'opt-neutral';
      let text = option;

      if (option.startsWith('+') || option.toLowerCase().startsWith('extra') || option.startsWith('✓') || option.startsWith('met ')) {
        iconClass = 'opt-include';
        text = option.replace(/^\+|^✓\s*/, '').trim();
      } else if (option.startsWith('-') || option.startsWith('✗') || option.startsWith('geen ') || option.startsWith('zonder ')) {
        iconClass = 'opt-exclude';
        text = option.replace(/^-|^✗\s*/, '').trim();
      } else if (option.toLowerCase().startsWith('alleen ')) {
        iconClass = 'opt-only';
        text = option;
      }

      return `<div class="opt-pill ${iconClass}">
        <svg class="opt-icon" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/>
          <path d="m12 5 7 7-7 7"/>
        </svg>
        <span class="opt-text">${text}</span>
      </div>`;
    }).join('');

    // Check if this item is a sauce product - if so, don't render it in the main list
    const isSauceProduct = item.products?.category?.slug === 'saus' || 
                          item.name_snapshot?.toLowerCase().includes('portie') ||
                          (item.name_snapshot && ['PORTIE MAYO', 'PORTIE CHILI', 'PORTIE CHILLI', 'CHILI SAUS', 'PORTIE SAMURAI', 'AMERIK. SPICY SAUS', 'PORTIE CURRY', 'PORTIE KETCHUP', 'PORTIE MOSTERD', 'PORTIE KNOFLOOK', 'PORTIE APPELMOES'].includes(item.name_snapshot.toUpperCase()));

    // If it's a sauce product, return empty string (don't show in main list)
    if (isSauceProduct) {
      return '';
    }

    return `
      <div class="item-card${displayOptions.length > 3 ? ' many-options' : ''}">
        <div class="item-left">
          <div class="item-title">
            <span class="item-qty">${item.qty}X</span>
            <span class="item-name">${item.name_snapshot}</span>
          </div>
          <div class="item-meta">
            <span class="item-price">€${(item.unit_price_cents / 100).toFixed(2).replace('.', ',')} per stuk</span>
            ${productNumber !== null ? `<span class="menu-badge">Menu ${productNumber}</span>` : ''}
          </div>
        </div>
        ${optionPills ? `<div class="opts-grid${displayOptions.length > 3 ? ' too-many' : ''}">${optionPills}</div>` : ''}
      </div>
    `;
  }).join('');

  const uniqueSauces = [...new Set(allSauces)];

  // Count duplicates for sauces
  const sauceCounts = {};
  allSauces.forEach(s => { sauceCounts[s] = (sauceCounts[s] || 0) + 1; });

  const saucesBoxHTML = Object.keys(sauceCounts).length > 0 ? `
    <div class="sauces-box">
      <div class="sauces-box-title">Sauzen</div>
      ${Object.entries(sauceCounts)
        .sort((a, b) => b[1] - a[1]) // Sort by quantity descending
        .map(([name, count]) => {
          // Clean up sauce names
          let cleanName = name;
          if (cleanName.toLowerCase().includes('appelmoes')) {
            cleanName = 'Appelmoes';
          }
          return `<div class="sauce-row">${count}x ${cleanName}</div>`;
        })
        .join('')}
    </div>
  ` : '';

  const isDelivery = order.delivery_type === 'delivery';

  return `
<!DOCTYPE html>
<html lang="nl">
<head>
  <meta charset="UTF-8">
  <title>KMFC - Bestelling ${orderNumber}</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Futura+PT:wght@400;500;600;700;800;900&display=swap" rel="stylesheet">
  <style>
    *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

    body {
      font-family: 'Futura PT', 'Helvetica Neue', Arial, sans-serif;
      background: #e8e8e8;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      min-height: 100vh;
      padding: 24px 16px;
      color: #111;
    }

    /* ── RECEIPT SHELL ── */
    .receipt {
      background: #fff;
      width: 440px;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 2px 24px rgba(0,0,0,0.10);
    }

    /* ── HEADER ── */
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px 22px 20px;
      border-bottom: 1.5px solid #e4e4e4;
    }

    .logo img {
      height: 160px;
      width: auto;
    }

    .header-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      min-width: 160px;
    }

    .header-date {
      font-size: 12px;
      font-weight: 600;
      color: #666;
      letter-spacing: 0.04em;
    }

    .header-time {
      font-size: 32px;
      font-weight: 900;
      color: #111;
      line-height: 1;
      letter-spacing: -0.02em;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .header-time svg {
      flex-shrink: 0;
    }

    /* ── ORDER BAR ── */
    .order-bar {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0;
      padding: 11px 22px;
      border-bottom: 1.5px solid #e4e4e4;
      font-size: 13px;
      font-weight: 700;
    }

    .order-bar-item {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .order-bar-sep {
      width: 1px;
      height: 14px;
      background: #d0d0d0;
      margin: 0 14px;
    }

    .order-num {
      font-weight: 900;
      font-size: 14px;
    }

    .bar-icon {
      font-size: 15px;
      opacity: 0.7;
    }

    /* ── SECTION HEADER ── */
    .section-header {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 13px 22px 9px;
      font-size: 13px;
      font-weight: 800;
      color: #555;
      text-transform: uppercase;
      letter-spacing: 0.07em;
    }

    .section-header svg {
      width: 15px;
      height: 15px;
      stroke: #555;
      fill: none;
      stroke-width: 2.2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    /* ── ITEMS ── */
    .items-list {
      padding: 0 14px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: stretch;
    }

    .item-card {
      border: 1.5px solid #e4e4e4;
      border-radius: 11px;
      padding: 11px 13px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
    }

    .item-card.many-options {
      flex-direction: column;
    }

    .item-left { 
      flex: 1; 
      min-width: 0;
      margin-right: 8px;
    }

    .item-title {
      display: flex;
      align-items: baseline;
      gap: 6px;
      margin-bottom: 4px;
    }

    .item-qty {
      font-weight: 900;
      font-size: 15px;
      color: #111;
      flex-shrink: 0;
    }

    .item-name {
      font-weight: 800;
      font-size: 13.5px;
      color: #111;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-meta {
      display: flex;
      align-items: center;
      gap: 7px;
    }

    .item-price {
      font-size: 12px;
      font-weight: 600;
      color: #666;
    }

    .menu-badge {
      background: #ebebeb;
      color: #333;
      border-radius: 20px;
      padding: 2px 9px;
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 0.01em;
    }

    /* ── OPTIONS GRID ── */
    .opts-grid {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      width: auto;
      min-width: 120px;
      max-width: 160px;
      margin-top: 6px;
      flex-shrink: 0;
    }

    .opts-grid.too-many {
      align-items: flex-start;
      width: 100%;
      max-width: none;
      min-width: auto;
      flex-wrap: wrap;
      margin-top: 8px;
    }

    .opt-pill {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.3;
      width: 100%;
      text-align: center;
    }

    .opts-grid.too-many .opt-pill {
      justify-content: flex-start;
      text-align: left;
    }

    .opt-icon {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
    }

    .opt-include .opt-icon {
      stroke: #000;
    }

    .opt-exclude .opt-icon {
      stroke: #000;
    }

    .opt-only .opt-icon,
    .opt-neutral .opt-icon {
      stroke: #000;
    }

    .opt-text {
      color: #222;
      font-size: 11.5px;
    }

    /* ── DIVIDER ── */
    .receipt-foot {
      height: 1.5px;
      background: #e4e4e4;
      margin: 14px 0 0;
    }

    .thank-you-section {
      text-align: center;
      padding: 16px 0 8px;
      margin-top: 8px;
    }

    .thank-you-text {
      font-size: 11px;
      font-weight: 600;
      color: #666;
      font-style: italic;
    }

    /* ── COST + SAUCES ROW ── */
    .bottom-row {
      display: flex;
      gap: 12px;
      padding: 14px 22px 0;
      align-items: flex-start;
    }

    .cost-block {
      flex: 1;
      font-size: 13px;
      font-weight: 700;
      line-height: 1.9;
    }

    .cost-line {
      display: flex;
      justify-content: space-between;
    }

    .cost-label { color: #444; }
    .cost-val { color: #111; font-weight: 700; }

    .cost-hr {
      border: none;
      border-top: 1.5px solid #222;
      margin: 5px 0;
    }

    .cost-total .cost-label,
    .cost-total .cost-val {
      font-size: 14px;
      font-weight: 900;
      color: #111;
    }

    .sauces-box {
      min-width: 136px;
      background: #f7f7f7;
      border: 1.5px solid #e4e4e4;
      border-radius: 10px;
      padding: 10px 13px;
      font-size: 12px;
      font-weight: 600;
      color: #333;
      line-height: 1.75;
    }

    .sauces-box-title {
      font-weight: 900;
      font-size: 12.5px;
      color: #111;
      margin-bottom: 3px;
    }

    .sauce-row { font-weight: 700; }

    /* ── DELIVERY ── */
    .delivery-section {
      margin: 14px 14px 0;
      border: 1.5px solid #e4e4e4;
      border-radius: 11px;
      padding: 16px;
    }

    .delivery-head {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      font-weight: 900;
      color: #111;
      margin-bottom: 12px;
    }

    .delivery-head svg {
      width: 16px;
      height: 16px;
      stroke: #111;
      fill: none;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    .delivery-body {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .delivery-info-row {
      display: flex;
      gap: 16px;
      align-items: flex-start;
    }

    .delivery-addr-row {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      font-size: 12.5px;
      color: #333;
      line-height: 1.4;
      cursor: pointer;
      padding: 2px 4px;
      border-radius: 4px;
      transition: background-color 0.2s;
    }

    .delivery-addr-row:hover {
      background-color: #f0f0f0;
    }

    .delivery-addr-row svg {
      width: 14px;
      height: 14px;
      stroke: #666;
      fill: none;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .drive-time {
      font-size: 13px;
      font-weight: 900;
      color: #111;
      cursor: pointer;
      padding: 2px 4px;
      border-radius: 4px;
      transition: background-color 0.2s;
    }

    .drive-time:hover {
      background-color: #f0f0f0;
    }

    .note-box {
      background: #f7f7f7;
      border: 1.5px solid #e4e4e4;
      border-radius: 10px;
      padding: 12px 14px;
      font-size: 12px;
      font-weight: 600;
      color: #333;
      line-height: 1.6;
    }

    .note-box strong {
      display: block;
      font-weight: 900;
      font-size: 12.5px;
      color: #111;
      margin-bottom: 4px;
    }

    /* ── BOTTOM PADDING ── */
    .receipt-foot { height: 20px; }

    /* ── PRINT ── */
    @media print {
      @page { size: A4; margin: 10mm; }
      body { background: white; padding: 0; }
      .receipt { box-shadow: none; width: 100%; border-radius: 0; }
      * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    }
  </style>
</head>
<body>
<div class="receipt">

  <!-- HEADER -->
  <div class="header">
    <div class="logo">
      <img src="/logofactuur.png" alt="KMFC Logo">
    </div>
    <div class="header-right">
      <div class="header-date">${orderDate}</div>
      <div class="header-time">
        ${isDelivery ? `
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        ` : `
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9,22 9,12 15,12 15,22"/>
        </svg>
        `}
        ${deliveryTime}${order.is_asap ? ' Z.S.M' : ''}
      </div>
    </div>
  </div>

  <!-- ORDER BAR -->
  <div class="order-bar">
    <div class="order-bar-item">
      <span class="order-num">${orderNumber}</span>
    </div>
    <div class="order-bar-sep"></div>
    <div class="order-bar-item">
      <span class="bar-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
      </span>
      <span>${order.customer_name || 'Gast'}</span>
    </div>
    ${order.customer_phone ? `
    <div class="order-bar-sep"></div>
    <div class="order-bar-item">
      <span class="bar-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.56 18a19.45 19.45 0 0 1-3.32-3.32 19.79 19.79 0 0 1-3.9-8.22A2 2 0 0 1 6.52 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L10.09 9.91a16 16 0 0 0 5 5l1.27-1.68a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      </span>
      <span>${order.customer_phone}</span>
    </div>` : ''}
  </div>

  <!-- BESTELLING LABEL -->
  <div class="section-header">
    <svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
    Bestelling
  </div>

  <!-- ITEMS -->
  <div class="items-list">
    ${itemsHTML}
  </div>

  <!-- COSTS + SAUCES -->
  <div class="section-divider"></div>
  <div class="bottom-row">
    <div class="cost-block">
      <div class="cost-line"><span class="cost-label">Subtotaal</span><span class="cost-val">€${(order.subtotal_cents / 100).toFixed(2).replace('.', ',')}</span></div>
      ${order.delivery_fee_cents > 0 ? `<div class="cost-line"><span class="cost-label">Bezorgkosten</span><span class="cost-val">€${(order.delivery_fee_cents / 100).toFixed(2).replace('.', ',')}</span></div>` : ''}
      ${order.tip_cents > 0 ? `<div class="cost-line"><span class="cost-label">Fooi</span><span class="cost-val">€${(order.tip_cents / 100).toFixed(2).replace('.', ',')}</span></div>` : ''}
      <hr class="cost-hr">
      <div class="cost-line cost-total"><span class="cost-label">Totaalbedrag</span><span class="cost-val">€${(order.total_cents / 100).toFixed(2).replace('.', ',')}</span></div>
    </div>
    ${saucesBoxHTML}
  </div>

  <!-- DELIVERY INFO -->
  ${isDelivery ? `
  <div class="delivery-section">
    <div class="delivery-head">
      <svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
      Bezorginformatie
    </div>
    <div class="delivery-body">
      <div class="delivery-info-row">
        ${order.delivery_address ? `
        <div class="delivery-addr-row" ondblclick="navigator.clipboard.writeText('${order.delivery_address}, ${order.delivery_postcode} ${order.delivery_city}').then(() => { this.style.backgroundColor = '#d4edda'; setTimeout(() => this.style.backgroundColor = '', 500); })">
          <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          <span>${order.delivery_address}, ${order.delivery_postcode} ${order.delivery_city}</span>
        </div>
        ` : ''}
        ${order.delivery_km ? `
        <div class="delivery-addr-row" ondblclick="navigator.clipboard.writeText('${formatKm(order.delivery_km)}').then(() => { this.style.backgroundColor = '#d4edda'; setTimeout(() => this.style.backgroundColor = '', 500); })">
          <svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
          <span>Afstand: ${formatKm(order.delivery_km)}</span>
        </div>
        ` : ''}
        ${order.driving_time ? `
        <div class="delivery-addr-row" ondblclick="navigator.clipboard.writeText('${order.driving_time} min').then(() => { this.style.backgroundColor = '#d4edda'; setTimeout(() => this.style.backgroundColor = '', 500); })">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span>Rijtijd: ${order.driving_time} min</span>
        </div>
        ` : ''}
      </div>
      ${order.delivery_notes ? `
      <div class="note-box">
        <strong>Bezorgopmerking</strong>
        ${order.delivery_notes}
      </div>
      ` : ''}
    </div>
  </div>
  ` : ''}

  <div class="thank-you-section">
    <div class="thank-you-text">Bedankt voor uw bestelling!</div>
  </div>
</div>
</body>
</html>
  `;
};